import * as React from "react";
import { showErrorToastr } from "src/app/shared/helpers/toastr-helper/ToastrHelper";
import { IContactItemInfoRouteParams } from "./~types/ContactItemInfoRouteParams";
import ContactSubtabs from "./contact-subtabs/ContactSubtabs";
import {ContactSubtabsEnum} from "./contact-subtabs/~types/ContactSubtabsProps"
import { IApplicationState } from "src/~store/models/ApplicationState";
import { IContactItemInfoProps } from "./~types/ContactItemInfoProps";
import { IContact } from "src/app/contact/~store/models/Contact";
import { Table, Button, Input } from "reactstrap";
import { connect } from "react-redux";
import { getDateTime } from "src/app/shared/helpers/date-helper/DateFormats";
import {
  selectedContactSelector,
  isReceivingContactSelector,
  countOfContactsSelector,
  contactsSelector,
  changedContactSelector,
  contactToMergeSelector,
  isRestoringContactSelector,
  accountTypesSelector,
  allChannelsSelector,
} from "src/app/contact/~store/selector";
import {
  saveContact,
  deleteContact,
  getContactById,
  changeSelectedContact,
  findContactByPhone,
  changeContactAvatar,
  undoChangesContactAvatar,
  saveAccount,
  deleteAccount,
  mergeContact,
  restoreContact,
  clearContactFoundByPhone,
  newChatWithMessenger,
  detachMessenger,
  getAccountTypes,
  getAllChannels,
  saveMessenger,
} from "src/app/contact/~store/actions/actions";

import ValidatableInput from "src/app/shared/components/validatable-input/ValidatableInput";
import TelephoneInput from "src/app/shared/components/telephone-input/TelephoneInput";
import ChangableImage from "src/app/shared/components/changable-image/ChangableImage";
import ContactAccountList from "./contact-account-list/ContactAccountList";

import "./ContactItemInfo.css";
import { URL_TO_CHATS_WITH_FILTER } from "./ContactItemInfoConstants";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { IAccount } from "src/app/contact/~store/models/Account";
import { initNewContact } from "src/app/contact/~store/state/InitContactState";
import {
  operatorIdSelector,
  operatorStatusSelector,
} from "src/app/chats-panel/~store/selectors";
import { OperatorStatusType } from "src/app/chats-panel/~store/state/ChatItemsState";
import { IMessenger } from "src/app/contact/~store/models/Messenger";
import { CHAT_NAME_MAX_LENGTH, COMMENT_MAX_LENGTH } from "src/~store/constants";
import { useTranslation } from "react-i18next";
import ContactCommunicationList from "./contact-communications-list/ContactCommunicationsList";
import { GET_FILE_BY_ID_API_ROUTE } from "src/app/chats-panel/~api/apiRoutes";
import { localeSelector } from "../../../../../setting/~store/selector";
import { isPhoneValid } from "../../../../../shared/helpers/phone-helper/PhoneHelper";
import { ModalWindow } from "src/app/shared/components/modal-window/ModalWindow";
import { GetColorFromString } from "src/app/shared/helpers/contact-avatar-helper/ContactAvatarHelper";
import { IInitiateConversationTemplate } from "src/app/chats-panel/~store/models/TemplateItem";

type ReduxType = ReturnType<typeof mapStateToProps> & IContactItemInfoProps;

const ContactItemInfo = (props: ReduxType) => {

  const [selectedTab, setSelectedTab] = React.useState<ContactSubtabsEnum>(ContactSubtabsEnum.contactCommunications);

  const { t } = useTranslation();

  const commentsInputRef = React.useRef<HTMLTextAreaElement>(null);

  const [canSave, setCanSave] = React.useState(false);
  const [isNew, setIsNew] = React.useState(false);
  const [phoneValid, setPhoneValid] = React.useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  const [isCommentModalWindowOpen, setIsCommentModalWindowOpen] = useState<boolean>(false);

  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [availableTemplates, setAvailableTemplates] = useState<IInitiateConversationTemplate[]>([]);
  const [selectedTemplateName, setSelectedTemplateName] = useState<string>('');
  const [selectedMessenger, setSelectedMessenger] = useState<IMessenger | null>(null);

    useEffect(() => {
    if (!props.allChannels || props.allChannels.length === 0) {
      props.getAllChannels();
    }
    if (!commentsInputRef.current) {
      return;
    }

    function resize(event: any) {
      const getElement = event.target;
      getElement.style.height = "auto";
      getElement.style.height =
        Math.max(getElement.scrollHeight, getElement.offsetHeight) + "px";
    }

    const textarea = commentsInputRef.current;
    textarea.addEventListener("input", resize);

    return () => {
      textarea.removeEventListener("input", resize);
    };
  }, []);

  useEffect(() => {
    let contactId = 0;
    let idFromUrl;
    const path = window.location.pathname;
    if (path.includes("/contacts/edit-contact/")) {
      idFromUrl = path.split("/")[path.split("/").length - 1];
      contactId = +idFromUrl;
    }
    if (isNaN(contactId)) {
      showErrorToastr(t("contact.contactReceivingByIdNotFoundMessage", { contactId: idFromUrl }));
      navigate("/contacts");
    } else if (contactId > 0) {
      props.getContactById(contactId, () => navigate("/contacts"));
    } else {
      setIsNew(true);
      const contact =
        props.changedContact.contactId === 0
          ? props.changedContact
          : initNewContact();

        contact.locale = props.defaultLocale;
      props.changeSelectedContact(contact);
    }
  }, [location]);

    useEffect(() => {
        if (!props.changedContact.locale) {
            props.changeSelectedContact({
                ...props.changedContact,
                locale: props.defaultLocale,
            });
        }
    }, [props.defaultLocale])

  const {
    createdOn,
    contactId,
    firstName,
    lastName,
    chatName,
    externalId,
    phone,
    patronymic,
    avatarId,
    chatsCount,
    contactComment,
    isDeleted,
    accounts,
    locale,
  } = props.changedContact;

  const anthroponymIsInvalid = (str: string | undefined): boolean => {
    return str === null || str === undefined ? false : str.trim() === '';
  }

  const anthroponymsAreForceValid = (): boolean => {
    return !anthroponymIsInvalid(firstName) || !anthroponymIsInvalid(lastName) || !anthroponymIsInvalid(patronymic);
  }

  const _getBody = (): React.ReactElement<{}> => {
    const contactAvatar =
      avatarId === null
        ? ""
        : GET_FILE_BY_ID_API_ROUTE +
              props.changedContact.avatarId;
      const fallbackIconColor = !contactAvatar ? GetColorFromString(props.changedContact?.externalId) : undefined;

    return (
        <React.Fragment>
        <Table className="contact-item-info__table">
          <tbody className="contact-item-info__table-body">
            <tr>
              <td className="contact-item-info__avatar-container">
                <ChangableImage
                  src={contactAvatar}
                  className={"contact-item-info__avatar"+ (!props.changedContact?.contactId ? " operator-avatar--disabled" : "")}
                  onImageChange={_onImageChangeHandler}
                  isActive={props.changedContact?.contactId !== undefined}
                  fallbackIconColor={fallbackIconColor}
                />
              </td>
              <td>
                <div>{t("common.created")} {getDateTime(createdOn)}</div>
                <div>{t("contact.chatsCount")} {chatsCount === 0 && chatsCount}
                  {chatsCount > 0 && (
                    <Link to={URL_TO_CHATS_WITH_FILTER + "contact:" + contactId}>
                      {chatsCount}
                    </Link>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td>{t("contact.firstName")}</td>
              <td>
                <ValidatableInput
                  id={"first-name-input" + contactId}
                  value={firstName ?? "unknown"}
                  onValueChange={_onFirstNameChangeHandler}
                  validate={_anthroponymValidation}
                  isValidForce={anthroponymsAreForceValid()}
                />
              </td>
            </tr>
            <tr>
              <td>{t("contact.lastName")}</td>
              <td>
                <ValidatableInput
                  id={"last-name-input" + contactId}
                  value={lastName ?? "unknown"}
                  onValueChange={_onLastNameChangeHandler}
                  validate={_anthroponymValidation}
                  isValidForce={anthroponymsAreForceValid()}
                />
              </td>
            </tr>
            <tr>
              <td>{t("contact.middleName")}</td>
              <td>
                <ValidatableInput
                  id={"patronymic-input" + contactId}
                  value={patronymic ?? "unknown"}
                  onValueChange={_onPatronymicChangeHandler}
                  validate={_anthroponymValidation}
                  isValidForce={anthroponymsAreForceValid()}
                />
              </td>
            </tr>
            <tr>
              <td>{t("contact.chatName")}</td>
                <td className="contact-item-info__chatName-input-container">
                <input
                  value={chatName ?? ""}
                  type="text"
                  maxLength={CHAT_NAME_MAX_LENGTH}
                  onChange={_onChatNameChangeHandler}
                />
              </td>
            </tr>
            <tr className="contact-item-info__phone-cell">
              <td>{t("contact.phoneNumber")}</td>
              <td className="contact-item-info__phone-input-cell">
                <TelephoneInput
                    containerClass="contact-item-info__telephone-container"
                    phoneNumber={phone ?? ""}
                    onChange={_onPhoneChangeHandler}
                    defLocale={locale}
                />
              </td>
            </tr>
            <tr>
              <td>{t("contact.comment")}</td>
              <td className="contact-item-info__comments-input-container">
                <Input
                  innerRef={commentsInputRef}
                  value={contactComment ?? ""}
                  type="textarea"
                  maxLength={COMMENT_MAX_LENGTH}
                  onChange={_onContactCommentChangeHandler}
                  className="contact-item-info__comments-input"
                />
              </td>
              <td>
                <button className="open-comment-in-full-screen" onClick={_commentOpen}>
                    <i className="material-icons">open_in_full</i>
                        </button>
                <ModalWindow 
                    className="setting-item-modal" 
                    isOpen={isCommentModalWindowOpen}
                    header={_getCommentHeader()}
                    body={_getCommentBody()}
                    footer={<></>}
                />
              </td>
            </tr>
            <tr className="contact-item-info__localization-cell">
              <td>{t("contact.locale")}</td>
              <td>
                <Input
                  type="select"
                  className="contact-account-item__type-input"
                  value={locale}
                  onChange={_onLocaleChangeHandler}
                >
                  <option>en-US</option>
                  <option>uk-UA</option>
                  <option>pl-PL</option>
                  <option>uz-Latn-UZ</option>
                  <option>kk-KZ</option>
                  <option>ru-RU</option>
                  <option>az-Latn-AZ</option>
                  <option>ky-KG</option>
                  <option>tg-Cyrl-TJ</option>
                  <option>ro-MD</option>
                  <option>ro-RO</option>
                  <option>hy-AM</option>
                </Input>
              </td>
              </tr>
                <tr className="contact-item-info__external-id-cell">
                    <td>
                        {t("contact.externalId")}
                    </td>
                    <td>{externalId}</td>
              </tr>
          </tbody>
            </Table>
            <ModalWindow
                className="whatsapp-template-modal"
                isOpen={isTemplateModalOpen}
                onClose={handleCloseModal}
                header={<span>{t("chat.selectTemplate")}</span>}
                body={
                    <div style={{ marginTop: '15px' }}>
                        <Input
                            type="select"
                            name="whatsappTemplate"
                            className="browser-default"
                            value={selectedTemplateName}
                            onChange={(e: any) => setSelectedTemplateName(e.target.value)}
                        >
                            {availableTemplates?.map((tpl: any, index: number) => (
                                <option key={index} value={tpl.template}>
                                    {tpl.template} ({tpl.lang})
                                </option>
                            ))}
                        </Input>
                    </div>
                }
                footer={
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', width: '100%' }}>
                        <Button onClick={handleCloseModal}>{t("common.cancel")} </Button>
                        <Button onClick={handleSendTemplateClick}> {t("common.send")} </Button>
                    </div>
                }
            />
      </React.Fragment>
    );
  };

  const _getFooter = (): React.ReactElement<{}> => {
    return (
      <React.Fragment>
        {!props.isRestoringContact && (
          <div className="contact-item-info__actions">
            {!isDeleted && (
              <Button
                className="contact-item-info__btn-save"
                onClick={_onSaveContactHandler}
                disabled={!canSave}
              >
                {t("common.save")}
              </Button>
            )}
            <Button
              className="contact-item-info__btn-cancel"
              onClick={_onCancelChangesHandler}
              disabled={!(canSave || isNew)}
            >
              {t("common.cancel")}
            </Button>
            {!isDeleted && (
              <Button
                className="contact-item-info__btn-delete"
                onClick={_onDeleteContactHandler}
                disabled={!_areAnySaved()}
              >
                {t("common.delete")}
              </Button>
            )}
            {isDeleted && (
              <Button
                className="contact-item-info__btn-restore"
                onClick={() =>
                  props.restoreContact(props.changedContact.contactId ?? 0)
                }
              >
                {t("common.restore")}
              </Button>
            )}
          </div>
        )}
        {!props.isReceivingContact && 
          <>
            <ContactSubtabs onTabChanged={setSelectedTab} selectedTab={selectedTab}/>
            {selectedTab===ContactSubtabsEnum.contactCommunications && 
              <ContactCommunicationList 
                selectedContact={props.selectedContact}
                messengers={props.selectedContact.messengers.sort((a,b) => b.messengerId - a.messengerId)} 
                newChatWithMessenger={_onNewChatWithMessenger}
                onDetach={props.detachMessenger}
                allChannels={props.allChannels}
                onSaveMessenger={(m) => props.saveMessenger(m, props.selectedContact.contactId)}/>}
            {selectedTab===ContactSubtabsEnum.accounts && (

                    <ContactAccountList
                        contactAccounts={accounts}
                        contactId={props.changedContact.contactId ?? 0}
                        saveAccount={props.saveAccount}
                        deleteAccount={props.deleteAccount}
                        getAccountTypes={props.getAccountTypes}
                        accountTypes={props.accountTypes}
                    />
            )}
          </>
        }
      </React.Fragment>
    );
  };

  const _onImageChangeHandler = (imageFile: File): void => {
    if (props.changedContact.contactId === undefined) {
      showErrorToastr(t("operators.changeAvatarNullIdErrorMessage"));
      return;
    }

    props.changeContactAvatar(imageFile, props.changedContact);
  };

  const _onSaveContactHandler = (): void => {
    const contact: IContact = {
      ...props.changedContact,
    };

    props.saveContact(contact, props.countOfContacts + 1);
    setCanSave(false);
    navigate(`/contacts`);
  };

  const _onCancelChangesHandler = (): void => {
    props.changeSelectedContact(Object.assign({}, props.selectedContact));
    if (props.changedContact.avatarId !== props.selectedContact.avatarId) {
      props.undoChangesContactAvatar(props.selectedContact);
    }
    setCanSave(false);
    navigate(`/contacts`);
  };

  const _onDeleteContactHandler = (): void => {
    props.deleteContact(props.selectedContact, props.countOfContacts + 1);
    navigate(`/contacts`);
  };

  const _onPhoneChangeHandler = (
    phoneNumber: string,
    countryData: any
  ): void => {
    /*if (isPhoneValid(phoneNumber, countryData.dialCode)) {
      props.findContactByPhone(phoneNumber);
    } else if (props.contactToMerge.contactId !== undefined) {
      console.log(true);
      props.clearContactFoundByPhone();
    }*/
    
    setPhoneValid(isPhoneValid(phoneNumber, countryData.dialCode));

    props.changeSelectedContact({
      ...props.changedContact,
      phone: phoneNumber,
    });
  };

  const _onLocaleChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const newLocale = event.currentTarget.value;
    props.changeSelectedContact({
      ...props.changedContact,
      locale: newLocale,
    });
  };

  const _onFirstNameChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const value = event.currentTarget.value;
    props.changeSelectedContact({
      ...props.changedContact,
      firstName: value,
    });
  };

  const _anthroponymValidation = (anthroponym: string): string => {
    return anthroponym.length === 0 ? t("contact.fillAtLeastOneAnthroponym") : "";
  };

  const _onLastNameChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const value = event.currentTarget.value;
    props.changeSelectedContact({
      ...props.changedContact,
      lastName: value,
    });
  };

  const _onContactCommentChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const value = event.currentTarget.value;
    props.changeSelectedContact({
      ...props.changedContact,
      contactComment: value,
    });
  };

  const _onPatronymicChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const value = event.currentTarget.value;
    props.changeSelectedContact({
      ...props.changedContact,
      patronymic: value,
    });
  };

  const _onChatNameChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const value = event.currentTarget.value;
    props.changeSelectedContact({
      ...props.changedContact,
      chatName: value,
    });
  };

  const _areAnyChanges = React.useCallback((): boolean => {
    const { selectedContact, changedContact, defaultLocale } = props;
      return (
        (selectedContact.firstName !== changedContact.firstName ||
        selectedContact.lastName !== changedContact.lastName ||
        selectedContact.patronymic !== changedContact.patronymic ||
        selectedContact.chatName !== changedContact.chatName ||
        selectedContact.phone !== changedContact.phone ||
        selectedContact.contactComment !== changedContact.contactComment ||
        (selectedContact.locale === "" ? changedContact.locale !== defaultLocale : selectedContact.locale !== changedContact.locale)) &&
        (!anthroponymIsInvalid(changedContact.firstName) || !anthroponymIsInvalid(changedContact.patronymic) || !anthroponymIsInvalid(changedContact.lastName)) &&
        phoneValid
      );
  }, [props.selectedContact, props.changedContact]);

  const _areAnySaved = (): boolean => {
    const { selectedContact} = props;
    return (
      selectedContact.firstName?.length !== 0 ||
      selectedContact.lastName?.length !== 0 ||
      selectedContact.patronymic?.length !== 0 ||
      selectedContact.chatName?.length !== 0 ||
      selectedContact.contactComment?.length !== 0 ||
      selectedContact.phone?.length !== 0
    );
  };

  const _onNewChatWithMessenger = (messenger: IMessenger): void => {
    if (props.operatorStatus === OperatorStatusType.Offline) {
      showErrorToastr(t("chatsPanel.errorReopenChatDueOfflineStatus"));
      return;
    }
    if (messenger.channelModel.type === 4) {
      showErrorToastr(t("chatsPanel.cannotOpenChatInWidgetChannel"));
      return;
    }
    if (window.confirm(t("contact.newDialogueWithClient"))) {
        props.newChatWithMessenger(
            messenger.messengerId,
            props.selectedContact.contactId,
            undefined,
            (templates) => {
                if (templates && templates.length > 0) {
                    setSelectedMessenger(messenger);
                    setAvailableTemplates(templates);
                    setSelectedTemplateName(templates[0].template);
                    setIsTemplateModalOpen(true);
                }
            }
        );
    }
    };

    const handleSendTemplateClick = () => {
        if (!selectedMessenger)
            return;

        setIsTemplateModalOpen(false);
        props.newChatWithMessenger(
            selectedMessenger.messengerId,
            props.selectedContact.contactId,
            selectedTemplateName
        );
    };

    const handleCloseModal = () => {
        setIsTemplateModalOpen(false);
        setSelectedMessenger(null);
    };

  const _commentOpen = (): void => {
    setIsCommentModalWindowOpen(!isCommentModalWindowOpen);
  };

  const _getCommentHeader = (): React.ReactElement<{}> => {
    return (
      <>
      {t("contact.comment")}
      <Button
      className="setting-header__close-button red"
      onClick={_commentOpen}>
      <i className="material-icons">
          close
      </i>
      </Button>
      </>
    );
  };

    const _getCommentBody = (): React.ReactElement<{}> => {
        return (
            <Input
            value={contactComment ?? ""}
            type="textarea"
            maxLength={COMMENT_MAX_LENGTH}
            onChange={_onContactCommentChangeHandler}
            style={{
                resize: "none",
                borderLeftStyle: "hidden",
                borderTopStyle: "hidden",
                borderRightStyle: "hidden",
                outline: "none",
                height: 500,
            }}
            />
        );
    };

  useEffect(() => {
    setCanSave(_areAnyChanges());
  }, [_areAnyChanges]);

  return (
    <div className="contact-item-info__container">
      {_getBody()}
      {_getFooter()}
    </div>
  );
};

const mapStateToProps = (state: IApplicationState) => {
  return {
    selectedContact: selectedContactSelector(state),
    isReceivingContact: isReceivingContactSelector(state),
    countOfContacts: countOfContactsSelector(state),
    contacts: contactsSelector(state),
    changedContact: changedContactSelector(state),
    contactToMerge: contactToMergeSelector(state),
    isRestoringContact: isRestoringContactSelector(state),
    operatorId: operatorIdSelector(state),
    operatorStatus: operatorStatusSelector(state),
    accountTypes: accountTypesSelector(state),
    allChannels: allChannelsSelector(state),
    defaultLocale: localeSelector(state)
  };
};

const mapDispatchToProps = (dispatch: any): IContactItemInfoProps => {
  return {
    saveContact: (contact: IContact, contactCountToGet: number) =>
      dispatch(saveContact(contact, contactCountToGet)),
    deleteContact: (contact: IContact, contactCountToGet: number) =>
      dispatch(deleteContact(contact, contactCountToGet)),
    getContactById: (contactId: number, onGoBackToContacts: () => void) =>
      dispatch(getContactById(contactId, onGoBackToContacts)),
    changeSelectedContact: (contact: IContact) =>
      dispatch(changeSelectedContact(contact)),
    findContactByPhone: (phone: string) => dispatch(findContactByPhone(phone)),
    changeContactAvatar: (file: File, contact: IContact) =>
      dispatch(changeContactAvatar(file, contact)),
    undoChangesContactAvatar: (contact: IContact) =>
      dispatch(undoChangesContactAvatar(contact)),
    saveAccount: (account: IAccount) => dispatch(saveAccount(account)),
    deleteAccount: (accountId: number) => dispatch(deleteAccount(accountId)),
    mergeContact: () => dispatch(mergeContact()),
    restoreContact: (contactId: number) => dispatch(restoreContact(contactId)),
    clearContactFoundByPhone: () => dispatch(clearContactFoundByPhone()),
    newChatWithMessenger: (
          messengerId: number,
          contactId: number,
          templateName?: string,
          onTemplateRequired?: (templates: IInitiateConversationTemplate[]) => void
      ) => newChatWithMessenger(messengerId, contactId, templateName, onTemplateRequired),
    detachMessenger: (messengerId: number) =>
      dispatch(detachMessenger(messengerId)),
    getAccountTypes: () => dispatch(getAccountTypes()),
    getAllChannels: () => dispatch(getAllChannels()),
    saveMessenger: (messenger: IMessenger, contactId: number) => dispatch(saveMessenger(messenger, contactId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactItemInfo);
